// UndoManager.jsx — Ctrl+Z / Ctrl+Shift+Z plošne (ústava 53.4 + 54.4, Mirko GO 18.7.)
// Vráti POSLEDNÚ MOJU akciu cez POST /api/undo/last (server: audit_log old_data reverz,
// whitelist tabuliek, 24 h okno, finančné moduly a odoslané dokumenty vylúčené).
// Mountnuté raz v Layout.jsx — skratky sa cez useShortcuts automaticky zapíšu do cheatsheetu (?).
import { useShortcuts } from '../hooks/useShortcuts.js'
import { useToast } from './Toast.jsx'
import { fetchAuth } from '../auth/fetchAuth.js'

export default function UndoManager() {
  const toast = useToast()
  const run = async (redo) => {
    try {
      const r = await fetchAuth('/api/undo/last', { method: 'POST', body: JSON.stringify({ redo }) })
      const d = await r.json()
      if (!r.ok) { (toast.info || toast.error)(d.error || (redo ? 'Niet čo zopakovať.' : 'Niet čo vrátiť.')); return }
      toast.success((redo ? 'Znova: ' : 'Vrátené: ') + (d.summary || d.entity_id) + ' — obnov zoznam, ak zmenu nevidíš.')
      window.dispatchEvent(new CustomEvent('matrix-undo-applied', { detail: d }))
    } catch (e) { toast.error('Vrátenie zlyhalo: ' + e.message) }
  }
  useShortcuts([
    { keys: 'mod+z', label: 'Vrátiť poslednú akciu (Undo)', scope: 'global', description: 'Vráti tvoju poslednú zmenu (úprava/zmazanie) — nie finančné zápisy ani odoslané dokumenty.', enableOnFormTags: false, handler: () => run(false) },
    { keys: 'mod+shift+z', label: 'Znova (Redo)', scope: 'global', description: 'Zopakuje naposledy vrátený krok.', enableOnFormTags: false, handler: () => run(true) },
  ])
  return null
}
